import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services';

import type { TypeGetOwnerSupplierListCodesResponse } from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사목록 필터 조회
 */
const useGetOwnerSupplierListCodes = () => {
  const endPoint = '/api-owner/owner-supplier/list/codes';

  const getOwnerSupplierListCodes = async () => {
    return axiosInstance
      .get<TypeGetOwnerSupplierListCodesResponse>(endPoint)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierListCodes };
};

export default useGetOwnerSupplierListCodes;

registerMockAPI<TypeGetOwnerSupplierListCodesResponse>({
  method: 'get',
  endpoint: '/api-owner/owner-supplier/list/codes',
  label: '화주사정보/공급사관리/필터옵션',
  scenarios: [
    {
      name: '정상 응답',
      response: {
        data: {
          searchFieldOption: [
            { code: 'OWNER_SUPPLIER_NAME', description: '공급사명' },
            { code: 'OWNER_SUPPLIER_CODE', description: '공급사코드' },
          ],
          dateOption: [
            { code: 'CREATED_AT', description: '등록일' },
            { code: 'MODIFIED_AT', description: '수정일' },
          ],
        },
      },
    },
  ],
});
